let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("aeSLG")]).then(() => parcelRequire('5snLG'));